import * as types from '../constants/actionTypes';
import * as userActions from "../graphql/actions/user";
import {addNotification as notify} from 'reapop';
import * as authHandler from "../utils/authHandler";

export function loggedIn(user)
{
    return {
        type: types.LOGGED_IN,
        payload: user
    };
}

export function failedToLogIn(user)
{
    return {
        type: types.FAILED_LOG_IN,
        payload: user
    };
}

export function loggingIn()
{
    return {
        type: types.LOGGING_IN,
    };
}

export function submitUser(user, pass) {
    return dispatch => {
        dispatch(loggingIn());
        userActions.submitUser(
            function (response) {
                if (response.data.getToken !== undefined && response.data.getToken.token !== undefined) {
                    authHandler.setToken(response.data.getToken.token);
                    authHandler.setUser(response.data.getToken.user);
                    dispatch(loggedIn(response.data.getToken.user));

                    if (authHandler.isLoggedIn()) {
                        document.location.href="/"
                    }
                }
            },
            function (error) {
                dispatch(failedToLogIn(error.message));
                dispatch(notify({message: error.message, status: 'error'}));
            },
            user, pass
        );
    };
}


// WEBPACK FOOTER //
// ./src/actions/login.js